import * as React from "react";
import { Box, Button, MenuItem, Select } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { SimpleSnackbar } from "../../../components/snackbar";
import { GiftModel } from "./table/gift.model";
import { AdmLayout } from "../../../layouts/base/adm.layout";
import { AdminFilterBar, AdminPageHeader, AppModal, countLabel, DataTable, EmptyState } from "../../../components/ui";
import { GiftForm } from "./form/gift-form";
import { useGiftPage } from "./use-gift-page";
import { buildGiftColumns } from "./gift-columns";

export const GiftPage: React.FC = () => {
    const {
        loading,
        searchValue,
        showSnackbar,
        setShowSnackbar,
        snackbarMessage,
        gifts,
        modalOpen,
        setModalOpen,
        formValid,
        setFormValid,
        planFilter,
        setPlanFilter,
        statusFilter,
        handleStatusChange,
        formRef,
        distinctPlans,
        displayedGifts,
        onHandleGiftAdd,
        handlePageChange,
        handlePageSizeChange,
        handleSearch,
    } = useGiftPage();

    const columns = buildGiftColumns();

    return (
        <AdmLayout loading={loading} hasLogo={true}>
            <SimpleSnackbar show={showSnackbar} message={snackbarMessage} onDismiss={() => setShowSnackbar(false)} />

            <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
                <AdminPageHeader
                    title="Brindes"
                    subtitle="Gestão de presentes"
                    action={
                        <Button
                            variant="contained"
                            startIcon={<AddRounded />}
                            onClick={() => setModalOpen(true)}
                            sx={{ height: 44, borderRadius: "12px", fontWeight: 600 }}
                        >
                            Conceder brinde
                        </Button>
                    }
                />

                <AdminFilterBar
                    search={searchValue}
                    onSearch={handleSearch}
                    placeholder="Buscar por e-mail..."
                    filters={
                        <>
                            <Select
                                size="small"
                                value={statusFilter}
                                onChange={(e) => handleStatusChange(e.target.value)}
                                sx={{ height: 40, minWidth: 160, borderRadius: "10px" }}
                            >
                                <MenuItem value="all">Todos os status</MenuItem>
                                <MenuItem value="unused">Não resgatados</MenuItem>
                                <MenuItem value="used">Resgatados</MenuItem>
                            </Select>
                            <Select
                                size="small"
                                value={planFilter}
                                onChange={(e) => setPlanFilter(e.target.value)}
                                sx={{ height: 40, minWidth: 160, borderRadius: "10px" }}
                            >
                                <MenuItem value="all">Todos os planos</MenuItem>
                                {distinctPlans.map((p) => (
                                    <MenuItem key={p} value={p}>
                                        {p}
                                    </MenuItem>
                                ))}
                            </Select>
                        </>
                    }
                    count={countLabel(displayedGifts.length, gifts.pagination.total)}
                />

                <DataTable<GiftModel>
                    columns={columns}
                    rows={displayedGifts}
                    countLabel={countLabel(displayedGifts.length, gifts.pagination.total)}
                    rowKey={(row) => String(row.id)}
                    loading={loading}
                    page={gifts.pagination.currentPage}
                    pageSize={gifts.pagination.perPage}
                    totalRows={gifts.pagination.total}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    pageSizeOptions={[5, 10, 25]}
                    minWidth={700}
                    emptyState={
                        <EmptyState
                            title="Nenhum brinde encontrado"
                            description="Crie um novo brinde para começar."
                            actionLabel="Novo brinde"
                            onAction={() => setModalOpen(true)}
                        />
                    }
                />
            </Box>

            <AppModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                kicker="Cadastrar"
                title="Novo brinde"
                maxWidth={560}
                footer={
                    <>
                        <Button variant="outlined" onClick={() => setModalOpen(false)} sx={{ height: 40, borderRadius: "10px" }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => formRef.current?.submit()}
                            disabled={!formValid}
                            sx={{ height: 40, borderRadius: "10px" }}
                        >
                            Salvar
                        </Button>
                    </>
                }
            >
                <GiftForm ref={formRef} onGiftAdded={onHandleGiftAdd} onValidChange={setFormValid} />
            </AppModal>
        </AdmLayout>
    );
};
